import { render } from "./ModalCreateDelivery.vue?vue&type=template&id=b7aa93cc&scoped=true"
import script from "./ModalCreateDelivery.vue?vue&type=script&lang=js"
export * from "./ModalCreateDelivery.vue?vue&type=script&lang=js"

import "./ModalCreateDelivery.vue?vue&type=style&index=0&id=b7aa93cc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7aa93cc"]])

export default __exports__